// extracted by mini-css-extract-plugin
export default {"redBlob":"Space_redBlob__OAsG9","blueBlob":"Space_blueBlob__bwM00","yellowBlob":"Space_yellowBlob__cBpK3","greenBlob":"Space_greenBlob__sPg7x","container":"Space_container__3yR9r"};